import * as React from 'react';

import * as TimeUtils from '@acceligentllc/shared/utils/time';

import { TimeFormat } from '@acceligentllc/shared/enums/timeFormat';

import LockedValue from 'af-components/LockedValue';

import CertificationStatusDisplay from './CertificationStatusDisplay';

interface WorkShiftType {
	accountId: number;
	certificationStatus: Nullable<string>;
	certificationReason: Nullable<string>;
	/** format: ISO_DATETIME */
	startTime: Nullable<string>;
	/** format: ISO_DATETIME */
	endTime: Nullable<string>;
	/** format: ISO_DATETIME */
	outdatedAt: Nullable<string>;
}

interface OwnProps {
	endTime: Nullable<string>;
	startTime: Nullable<string>;
	totalTime: number;
	workShifts: WorkShiftType[];
	timeZoneOffset: number;
}

type Props = OwnProps;

const formatTime = (time: Nullable<string>) => {
	const formatted = time ? TimeUtils.formatDate(time, TimeFormat.TIME_ONLY_12H, TimeFormat.ISO_DATETIME) : null;

	return !!formatted ? formatted : '-';
};

const TimeSheetTime: React.FC<Props> = (props) => {
	const { endTime, startTime, totalTime, workShifts, timeZoneOffset } = props;

	const renderCertStatusList = React.useCallback((workshifts: WorkShiftType[]): React.JSX.Element => {
		return <>{workshifts.map((ws: WorkShiftType) =>
			<CertificationStatusDisplay
				key={`${ws.accountId}:${ws.startTime}-${ws.endTime}`}
				timeZoneOffset={timeZoneOffset}
				workShift={ws}
			/>
		)}</>;
	}, [timeZoneOffset]);

	return (
		<div className="time-sheet-list__row__info__total-time-container">
			<div>
				<LockedValue label="Start" value={formatTime(startTime)} />
			</div>
			<div>
				{!!endTime && (
					<LockedValue
						label={'.'/** hack to align values from Locked values */}
						labelClassName="time-sheet-list__row__info__total-time-container-empty-label"
						value="-"
					/>
				)}
			</div>
			<div>
				<LockedValue label="Finish" value={formatTime(endTime)} />
			</div>
			<div /> {/* used to double the gap between items */}
			<div>
				<LockedValue label="Total" value={TimeUtils.minutesToHoursAndMinutes(totalTime)} />
			</div>
			<div /> {/* used to double the gap between items */}
			{workShifts?.length > 0 ?
				<div>
					<LockedValue label="Certification Status" value={renderCertStatusList(workShifts)} valueClassName={'locked-input-one-row locked-input-one-row__content'} />
				</div> : null
			}
		</div>
	);
};

export default React.memo(TimeSheetTime);
